import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useMovimentoReduzido } from "../../contextos/PreferenciasContext";

const transicoes = {
  navegacao: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Padrão das páginas iniciais: cabeçalho primeiro e cards em sequência.
export function obterTransicaoPaginaInicial(
  tipo,
  indice = 0,
  reduzirMovimento = false,
) {
  const cabecalho = tipo === "cabecalho";

  return {
    initial: reduzirMovimento ? false : { opacity: 0, y: cabecalho ? 8 : 16 },
    animate: { opacity: 1, y: 0 },
    transition: reduzirMovimento
      ? { duration: 0 }
      : {
          duration: cabecalho ? 0.6 : 0.7,
          delay: cabecalho ? 0 : 0.2 + indice * 0.15,
          ease: "easeInOut",
        },
  };
}

const TransicaoPagina = React.forwardRef(function TransicaoPagina(
  {
    children,
    variante = "navegacao",
    carregando = false,
    carregamento = null,
    className,
    style,
    ...props
  },
  ref,
) {
  const { pathname } = useLocation();
  const reduzirMovimento = useMovimentoReduzido();

  const propriedadesContainer = {
    ...props,
    ref,
    className,
    style: { width: "100%", ...style },
  };

  if (variante === "entrada") {
    return <div {...propriedadesContainer}>{children}</div>;
  }

  if (carregando) {
    return <div {...propriedadesContainer}>{carregamento}</div>;
  }

  const configuracao = transicoes[variante] || transicoes.navegacao;

  return (
    <motion.div
      {...propriedadesContainer}
      key={pathname}
      onUpdate={() => {}}
      initial={reduzirMovimento ? false : configuracao.initial}
      animate={configuracao.animate}
      transition={reduzirMovimento ? { duration: 0 } : configuracao.transition}
    >
      {children}
    </motion.div>
  );
});

export default TransicaoPagina;
